import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveJobSeekerProfileStructuredDataMutationVariables = Types.Exact<{
  input: Types.RemoveJobSeekerProfileStructuredDataInput;
}>;


export type RemoveJobSeekerProfileStructuredDataMutation = { __typename?: 'Mutation', removeJobSeekerProfileStructuredData?: { __typename: 'RemoveJobSeekerProfileStructuredDataPayload' } | null };


export const RemoveJobSeekerProfileStructuredDataDocument = gql`
    mutation removeJobSeekerProfileStructuredData($input: RemoveJobSeekerProfileStructuredDataInput!) {
  removeJobSeekerProfileStructuredData(input: $input) {
    __typename
  }
}
    `;
export type RemoveJobSeekerProfileStructuredDataMutationFn = Apollo.MutationFunction<RemoveJobSeekerProfileStructuredDataMutation, RemoveJobSeekerProfileStructuredDataMutationVariables>;

/**
 * __useRemoveJobSeekerProfileStructuredDataMutation__
 *
 * To run a mutation, you first call `useRemoveJobSeekerProfileStructuredDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobSeekerProfileStructuredDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobSeekerProfileStructuredDataMutation, { data, loading, error }] = useRemoveJobSeekerProfileStructuredDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveJobSeekerProfileStructuredDataMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobSeekerProfileStructuredDataMutation, RemoveJobSeekerProfileStructuredDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJobSeekerProfileStructuredDataMutation, RemoveJobSeekerProfileStructuredDataMutationVariables>(RemoveJobSeekerProfileStructuredDataDocument, options);
      }
export type RemoveJobSeekerProfileStructuredDataMutationHookResult = ReturnType<typeof useRemoveJobSeekerProfileStructuredDataMutation>;
export type RemoveJobSeekerProfileStructuredDataMutationResult = Apollo.MutationResult<RemoveJobSeekerProfileStructuredDataMutation>;
export type RemoveJobSeekerProfileStructuredDataMutationOptions = Apollo.BaseMutationOptions<RemoveJobSeekerProfileStructuredDataMutation, RemoveJobSeekerProfileStructuredDataMutationVariables>;